import { useEffect, useRef } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

function extractJamParams(search: string) {
  const params = new URLSearchParams(search);
  const result = new URLSearchParams();

  for (const [key, value] of params.entries()) {
    if (key.startsWith('jam-')) {
      result.append(key, value);
    }
  }

  return result;
}

export function JamParams() {
  const location = useLocation();
  const navigate = useNavigate();

  const persistedJamParams = useRef<URLSearchParams | null>(null);

  useEffect(() => {
    const currentParams = new URLSearchParams(location.search);

    if (!persistedJamParams.current) {
      const jamParams = extractJamParams(location.search);
      if ([...jamParams.keys()].length > 0) {
        persistedJamParams.current = jamParams;
      }
    }

    if (!persistedJamParams.current) return;

    let changed = false;

    for (const [key, value] of persistedJamParams.current.entries()) {
      if (!currentParams.has(key)) {
        currentParams.set(key, value);
        changed = true;
      }
    }

    if (changed) {
      navigate(`${location.pathname}?${currentParams.toString()}`, { replace: true });
    }
  }, [location, navigate]);

  return <Outlet />;
}
